export default __webpack_public_path__ + "static/media/kyoto.2367f537.jpg";